import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty, split, filter, forEach } from 'lodash';
import AddTaxDetails from './AddTaxDetails';
import { Spinner } from 'shared-components/decorators/spinner';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { TAX_DETAILS_SCOPE } from '../TaxDetails/TaxDetails.consts';

class AddTaxDetailsContainer extends Component {
  constructor (props) {
    super(props);
  }

  render () {
    const {
      dispatch, isVatEnabled = false, pageErrorBlock = null, profile, fee_profiles,
      taxDetailsScope, globalCountries, fees, feeProfile, accessToken, isCanadaProfile, countryData, formattedBillingAddress } = this.props;

    const isProvincial = TAX_DETAILS_SCOPE.subregion === taxDetailsScope;
    const countryTaxKey = isCanadaProfile ? 'gst_hst' : get(fees, 'feeTypes[0].name', 'other');
    const provincialFee = filter(get(fees, 'feeTypes', []), (fee) => {
        return fee.is_subregion;
      });

    const intlTranslationsKey = isProvincial && (isCanadaProfile || !isEmpty(provincialFee)) ?
        'all_provinces' : countryTaxKey;

    const locale = split(SharedIntlProviderHOC.getLocale(), '-', 1)[0];
    const userCountry = get(feeProfile, 'country') || locale.split('-')[1];
    const canadaProvince = isCanadaProfile ? get(feeProfile, 'state', null) : null;

    const regionalFeesFetched = get(fees, 'hasFetched', false);
    const isHost = get(profile, 'is_host', false);

    const vatAddress = get(fee_profiles, 'vatAddress.data', []);
    const billingAddress = get(fee_profiles, 'billingAddress.data', []);
    const feeProfileAddress = isEmpty(vatAddress) ? billingAddress[0] : vatAddress[0];
    const feeProfilesFetched = get(fee_profiles, 'vatAddress.hasFetched', false);
    const translationsKeyAssigned = intlTranslationsKey.length > 0;

    const vatProfiles = get(fee_profiles, 'vatAddress.data');
    let federalVat = {};
    let subRegionVat = {};

    forEach(vatProfiles, (profile) => {
      if (get(profile, 'is_subregion')) {
        subRegionVat = profile;
      } else {
        federalVat = profile;
      }
    });

    const federalVatProfileId = get(federalVat, '_id', '');
    const subRegionVatProfileId = get(subRegionVat, '_id', '');

    // Whether this is an add or an update is a fact about the store, not the URL:
    // a registration for this scope either exists or it does not.
    const isEdit = !isEmpty(isProvincial ? subRegionVat : federalVat);

    if (isVatEnabled) {
      // A `?scope=` we do not serve.
      if (!taxDetailsScope) {
        return pageErrorBlock();
      }

      return (
        <div className="AddTaxDetailsContainer">
          {
            (!feeProfilesFetched || !regionalFeesFetched || !translationsKeyAssigned) ?
              <div className="spinner-container">
                <Spinner additionalStyle="gray" />
              </div>
              :
              <AddTaxDetails
                {...this.props}
                address={feeProfile}
                orderedAddressFields={formattedBillingAddress}
                countryData={countryData}
                isProvincial={isProvincial}
                pageErrorBlock={pageErrorBlock}
                globalCountries={globalCountries}
                intlTranslationsKey={intlTranslationsKey}
                federalVatProfile={federalVat}
                subRegionVatProfile={subRegionVat}
                federalVatProfileId={federalVatProfileId}
                subRegionVatProfileId={subRegionVatProfileId}
                isEdit={isEdit}
                isHost={isHost}
              />
          }
        </div>
      );
    }

    return pageErrorBlock();
  }
}

AddTaxDetailsContainer.propTypes = {
  fee_profiles: PropTypes.object,
  pageErrorBlock: PropTypes.func,
  isVatEnabled: PropTypes.bool,
  profile: PropTypes.object,
  taxDetailsScope: PropTypes.string,
  formattedBillingAddress: PropTypes.array,
  countryData: PropTypes.object
};

export default AddTaxDetailsContainer;
